export default {
    workOrder_trackerTab_workOrderNumber: "Work Order Number",
    workOrder_trackerTab_scheduledDate: "Scheduled Date",
    workOrder_trackerTab_customer: "Customer",
    workOrder_trackerTab_status: "Status",
    workOrder_trackerTab_statusUpdatedOn: "Status Updated On",
    workOrder_trackerTab_address: "Address",
    workOrder_trackerTab_type: "Type",
    workOrder_trackerTab_duration: "Duration (Mins)",
    workOrder_trackerTab_severity: "Severity",
    workOrder_trackerTab_changeStatus: "Change Status",
    workOrder_trackerTab_viewAnswer: "View answer",
    workOrder_trackerTab_arrivalTime: "Arrival Time",
    workOrder_trackerTab_departureTime: "Departure Time",
    workOrder_trackerTab_noUnit: "No Unit Assigned",
    workOrder_trackerTab_customer_name: "Customer Name",
    workOrder_trackerTab_contact_name: "Contact Name",
    workOrder_trackerTab_driver: "Driver",
    workOrder_trackerTab_date: "Date",
    search_workOrder_trackerTab: "Search by Driver Name, Work Order Number, Customer Name, Contact Name | email | phone, description"
};